import { useState, type ReactNode } from 'react'
import { ChevronDown } from 'lucide-react'
import { csLabelClass } from '@/components/Cs/csFormStyles'

export function CsSection({
  title,
  action,
  children,
  collapsible = false,
  defaultOpen = true,
}: {
  title: string
  action?: ReactNode
  children: ReactNode
  collapsible?: boolean
  defaultOpen?: boolean
}) {
  const [open, setOpen] = useState(defaultOpen)
  const showBody = !collapsible || open

  return (
    <section className='glass-card p-4 md:p-5'>
      <div
        className={`flex flex-wrap items-center justify-between gap-2 ${showBody ? 'mb-3' : ''}`}
      >
        {collapsible ? (
          <button
            type='button'
            onClick={() => setOpen((v) => !v)}
            className='flex min-w-0 flex-1 items-center gap-2 text-left'
            aria-expanded={open}
          >
            <h3 className='text-sm font-semibold text-[var(--text-primary)]'>{title}</h3>
            <ChevronDown
              size={16}
              className={`shrink-0 text-[var(--text-muted)] transition-transform ${
                open ? 'rotate-0' : '-rotate-90'
              }`}
            />
          </button>
        ) : (
          <h3 className='text-sm font-semibold text-[var(--text-primary)]'>{title}</h3>
        )}
        {action}
      </div>
      {showBody ? children : null}
    </section>
  )
}

export function CsField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className='mb-3 last:mb-0'>
      <label className={csLabelClass}>{label}</label>
      {children}
    </div>
  )
}

export function CsInfoRow({ label, value }: { label: string; value?: string | null }) {
  return (
    <div className='flex justify-between gap-4 border-b border-[var(--glass-border)] py-2 text-sm last:border-0'>
      <span className='text-[var(--text-muted)]'>{label}</span>
      <span className='text-right text-[var(--text-primary)]'>{value || '—'}</span>
    </div>
  )
}
